module.exports = __webpack_public_path__ + "static/img/NoData_icon@2x.2fc3c441.png";